import moment from 'moment-jalaali';

export const yearRange = (): number[] =>
  Array.from(
    { length: moment(new Date()).jYear() - 1300 + 1 },
    (_, index) => 1300 + index
  );

export const generateDayOfMonth = (year: number, month: number): number[] =>
  Array.from(
    {
      length: moment.jDaysInMonth(year, Number(month - 1))
    },
    (_, index) => index + 1
  );
